enum Env {
  Production = 'production',
  Staging = 'staging',
  Development = 'development',
  Test = 'test',
}

const ENV_MAP: Record<string, Env> = {
  production: Env.Production,
  preview: Env.Staging,
  development: Env.Development,
  test: Env.Test,
};

//VITE_ENV is defined in vite.config.ts at build time
const VITE_ENV_VAR = 'VITE_ENV';
const CURRENT_ENV =
  ENV_MAP[
    process.env.NODE_ENV === 'development' ? 'development' : VITE_ENV_VAR
  ];

/**
 * Kept deliberately separate from `CURRENT_ENV` above, which `cep.config.ts`
 * imports to pick the extension id — and whose value `nodeScripts/changeScriptId.js`
 * depends on. That expression is left byte-for-byte as it was so the build chain
 * behaves identically; everything below is additive.
 *
 * `process.env.NODE_ENV` rather than the `VITE_ENV` define, because that define
 * cannot carry a value: vite substitutes `define` strings as *raw expressions*,
 * so `define: { VITE_ENV: 'production' }` emits the bare identifier `production`
 * and every read of it is `undefined` (verified in the built bundle). vite does
 * statically replace `process.env.NODE_ENV` in client code, and the expression
 * stays a plain, non-throwing read in Node, where `cep.config.ts` imports this
 * module without vite's transform.
 *
 * Granularity note: `yarn build` and `yarn build-prod` emit a byte-identical
 * client bundle, so no source-visible signal can separate them. Every built
 * artifact therefore reports production, a local `yarn build` included.
 */
const IS_PRODUCTION = process.env.NODE_ENV === Env.Production;

/**
 * Environment slug attached to every analytics event. `CURRENT_ENV` above can
 * legitimately resolve to `undefined`, and PostHog silently drops undefined
 * properties, so events carry this instead.
 */
const ANALYTICS_ENV: Env = IS_PRODUCTION ? Env.Production : Env.Development;

export { ANALYTICS_ENV, CURRENT_ENV, Env, IS_PRODUCTION };
